import { v4 as uuid } from 'uuid';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import View from '@kitconcept/volto-carousel-block/components/View';
import Sidebar from '@kitconcept/volto-carousel-block/components/Sidebar';

const CarouselEdit = (props) => {
  const { onChangeBlock, block, selected } = props;
  const data = {
    columns: [{ '@id': uuid() }, { '@id': uuid() }],
    items_to_show: 1,
    ...props.data,
  };
  if (!props.data.columns) {
    onChangeBlock(block, data);
  }

  return (
    <>
      <View {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <Sidebar
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default CarouselEdit;
